"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../../../../reducers/slices/main");
var issue_voucher_1 = __importDefault(require("../../issue_voucher"));
var react_1 = require("react");
function useActionButtons() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var clientUsers = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).clientUsers;
    var loggedInUser = clientUsers === null || clientUsers === void 0 ? void 0 : clientUsers.find(function (clientUser) { return clientUser.user_id === (user === null || user === void 0 ? void 0 : user._id); });
    var showIssueVoucherModal = function () {
        return dispatch((0, main_1.setContentModal)({
            title: "Issue Voucher",
            content: (0, jsx_runtime_1.jsx)(issue_voucher_1.default, {}),
        }));
    };
    var actionButtons = (0, react_1.useMemo)(function () {
        var _a, _b;
        return ((_b = (_a = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.user_permissions) === null || _a === void 0 ? void 0 : _a.VOUCHERS) === null || _b === void 0 ? void 0 : _b.create)
            ? [
                {
                    iconClassname: "solar:add-circle-bold",
                    label: "Issue Voucher",
                    onClick: function () {
                        showIssueVoucherModal();
                    },
                },
            ]
            : [];
    }, [loggedInUser, showIssueVoucherModal]);
    return (0, react_1.useMemo)(function () { return ({
        actionButtons: actionButtons,
    }); }, [actionButtons]);
}
exports.useActionButtons = useActionButtons;
